import React, { useState } from "react";
import { api } from "../api";
import Modal from "../components/Modal";

export default function Settings() {
  const [endOfSeason, setEndOfSeason] = useState(false);
  const [confirmText, setConfirmText] = useState("");
  const [running, setRunning] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState(null);

  const onEndOfSeason = async () => {
    setError(null);
    setRunning(true);
    try {
      const res = await api.endOfSeason(confirmText);
      setResult(res);
      setEndOfSeason(false);
      setConfirmText("");
    } catch (err) {
      setError(err.message);
    } finally {
      setRunning(false);
    }
  };

  return (
    <div className="space-y-4">
      <h1 className="text-2xl">Einstellungen</h1>

      <div className="card p-5">
        <h2 className="font-semibold">Daten-Export</h2>
        <p className="text-sm text-fh-gray mt-1">Excel-Exporte für externe Verarbeitung.</p>
        <div className="flex flex-wrap gap-2 mt-4">
          <a href={api.exportData()} className="btn-secondary" download>📥 Alle Verleih-Daten</a>
          <a href={api.exportRapidmail()} className="btn-secondary" download>📥 Rapidmail (Kunden)</a>
        </div>
      </div>

      <div className="card p-5 border-l-4 border-fh-red">
        <h2 className="font-semibold text-fh-red">Saisonende-Reset</h2>
        <p className="text-sm text-fh-gray mt-1">
          Erstellt zuerst ein vollständiges Backup, danach werden alle Verleihe + Verleih-Historie gelöscht.
          <br />
          Items, Equipment-Modelle, Standorte und Mitarbeiter bleiben erhalten.
        </p>
        <button onClick={() => setEndOfSeason(true)} className="btn-danger mt-4">
          🧹 Saisonende durchführen
        </button>
      </div>

      <Modal
        open={endOfSeason}
        title="Saisonende — Bestätigung"
        onClose={() => { setEndOfSeason(false); setConfirmText(""); setError(null); }}
        footer={
          <>
            <button className="btn-secondary" onClick={() => { setEndOfSeason(false); setConfirmText(""); }} disabled={running}>Abbrechen</button>
            <button className="btn-danger" onClick={onEndOfSeason} disabled={confirmText !== "SAISONENDE" || running}>
              {running ? "Läuft…" : "Reset durchführen"}
            </button>
          </>
        }
      >
        {error && <div className="bg-fh-red/10 text-fh-red-dark text-sm px-3 py-2 rounded mb-3">{error}</div>}
        <div className="space-y-3">
          <p className="text-sm">
            Vor dem Reset wird ein automatisches Backup im Server-Verzeichnis <code className="font-mono text-xs bg-fh-gray-light px-1">backups/</code> erstellt.
          </p>
          <p className="text-sm">
            <strong>Gelöscht werden:</strong> Alle Rentals + Verleih-Historie.<br />
            <strong>Bleibt:</strong> Items (Status zurück auf "verfügbar"), Modelle, Standorte, Mitarbeiter-Accounts.
          </p>
          <div>
            <label className="label-field">Tippe „SAISONENDE" zur Bestätigung</label>
            <input
              className="input-field font-mono"
              value={confirmText}
              onChange={(e) => setConfirmText(e.target.value)}
              placeholder="SAISONENDE"
              autoFocus
            />
          </div>
        </div>
      </Modal>

      <Modal
        open={!!result}
        title="Saisonende erfolgreich"
        onClose={() => setResult(null)}
        footer={<button className="btn-primary" onClick={() => setResult(null)}>OK</button>}
      >
        {result && (
          <div className="text-sm space-y-2">
            <p className="text-green-700 font-medium">✅ Backup erstellt + Daten zurückgesetzt</p>
            <div className="bg-fh-gray-light rounded p-3 font-mono text-xs space-y-1">
              <div>Backup: {result.backup_dir}</div>
              <div>SHA256: {result.db_sha256?.slice(0, 16)}…</div>
              <div className="pt-2 border-t border-gray-200">
                Gelöscht: {result.removed?.rentals} Rentals · {result.removed?.rental_equipment} Verleih-Einträge
              </div>
              <div>
                Behalten: {result.preserved?.users} User · {result.preserved?.equipment_models} Modelle · {result.preserved?.items} Items
              </div>
            </div>
          </div>
        )}
      </Modal>
    </div>
  );
}
